/**
 * banniere.js
 */

// Import
import "./profile.scss";
import $ from 'jquery';

$(document).ready(function() {
    console.log('override: components/profile');

    //DROPDOWN STATUT
  /* $('#voirEnTantQueStatut ').on('click','button', function(e) {

        e.preventDefault();
        var voirEnTantQue =$('#voirEnTantQueEmploye').data('type') + $(this).data( 'type' );
        $.ajax({
            url : vradho.ajax_url,
            data : {
                action : 'voir_comme',
                statut_emplois : voirEnTantQue,
                nonce: vradho.nonce
            },
            success : function( response ) {
                $('#statut_emploi').text('succès : ' + response);
                location.reload();
            },
            error : function () {
                $('#statut_emploi').text('erreur : ' + voirEnTantQue);
            }
        });
       console.log(  'voir en tant que statut '+ voirEnTantQue );
    });*/

    //DROPDOWN EMPLOYE
    $('#voirEnTantQueEmploye button').on('click', function(e) {
        e.preventDefault();

        var voirEnTantQue = $(this).data( 'type' ) /*+ $('#voirEnTantQueStatut').data('type')*/;
        $.ajax({
            url : vradho.ajax_url,
            data : {
                action : 'voir_comme',
                statut_emplois : voirEnTantQue,
                nonce: vradho.nonce
            },
            success : function( response ) {
                $('#statut_emploi').text('succès : ' + response);
                location.reload();
            },
            error : function () {
                $('#statut_emploi').text('erreur : ' + voirEnTantQue);
            }
        });
    });


    /* Permet de garder le menu utilisateur ouvert quand on clique sur le bouton de changement de profil employé */
    $("#btnGroupDrop2").on("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).siblings().toggleClass("show");

    });



    if($("article.page .entry-content").text().replace(/\s+/g, '') === "")
        $("article.page .entry-content").html("<p>Désolé, cette page ne contient aucune information concernant le type d'emploi sélectionné.</p>");


});





